// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"v9","title":"v-","notSelected":"v_","duration":"wa","image":"wb","infoWrapper":"wc","description":"wd"};